import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
// import useMediaQuery from "@mui/material/useMediaQuery";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import LoadingButton from "@mui/lab/LoadingButton";

// import QRCode from "../../assets/img/pix-pitaya.jpeg";
import toast from "react-hot-toast";
// import LoaderPage from "../loader";

import { storage } from "../../utils/firebase/firebase";
import { ref, getDownloadURL } from "firebase/storage";
import CircularProgress from "@mui/material/CircularProgress";

import { getTransactionsQuery } from "../../utils/firebase/firebase.datatable";

const PixGerado = ({ value, email, MySwal }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	// const isNonMobile = useMediaQuery("(min-width: 800px)");
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(true);
	const [pixUrl, setPixUrl] = useState("");
	const [imgDone, setImgDone] = useState(true);

	const storageRef = ref(storage, `img/pix-pitaya.jpeg`);

	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		minimumFractionDigits: 2
	});

	const handlerCopy = () => {
		navigator.clipboard.writeText("30822328000154");
		toast.success("Chave PIX Copiada");
	};

	const handleFinal = async () => {
		try {
			await getTransactionsQuery();
		} catch (err) {
			console.log("error pegar dados: ", err);
		}
		navigate("/");
	};

	const handlerDoneImg = () => {
		setImgDone(false);
	};

	useEffect(
		() => {
			getDownloadURL(storageRef).then(downloadURL => {
				setPixUrl(downloadURL);
			});
		},
		[storageRef]
	);

	useEffect(() => {
		if (pixUrl.length > 0) {
			if (!imgDone) {
				MySwal.fire("Feito", "Pix gerado com sucesso!!", "success");
			}
			setIsLoading(false);
		}
	}, [pixUrl, imgDone,MySwal]);

	console.log(pixUrl);
	return (
		<div>
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				p="10px"
				sx={{
					gap: "30px",
					width: "100%",
					marginTop: "120px",
				}}
			>
				<Box display="flex" justifyContent="center" alignItems="center">
					<Typography variant="h5" color={colors.primary[100]}>
						PIX: 30.822.328/0001-54
					</Typography>
					<FileCopyOutlinedIcon
						onClick={handlerCopy}
						sx={{
							cursor: "pointer",
							marginLeft: "10px",
							color: `${colors.primary[100]}`
						}}
					/>
				</Box>
				<Box>
					<img
						src={pixUrl}
						style={{ display: !imgDone ? "block" : "none" }}
						alt="qr-code"
						width={250}
						height={250}
						onLoad={() => handlerDoneImg()}
					/>

					{imgDone && <CircularProgress color="inherit" />}
				</Box>

				<Typography variant="h1" color={colors.greenAccent[500]}>
					{formatter.format(value)}
				</Typography>
				<Box display="flex" justifyContent="center" alignItems="center">
					<Typography variant="h6" color={colors.primary[100]}>
						Pagador: <b style={{ fontStyle: "italic" }}>{email}</b>
					</Typography>
				</Box>
				<LoadingButton
					loading={false}
					type="submit"
					sx={{
						backgroundColor: colors.greenAccent[600],
						// width: isNonMobile ? "50%" : "80%",
						width: "100%",
						borderRadius: "60px"
					}}
					variant="contained"
					onClick={handleFinal}
					// disabled={isValid}
				>
					Finalizar
				</LoadingButton>
			</Box>
		</div>
	);
};

export default PixGerado;
